<template>
  <div class="wrap coaching-journal-wrap">
    <div class="top-header">
      <incBack></incBack>
      <h3>고객 / 코칭 일지</h3>
    </div>
    <div class="body-wrap">
      <incMenuShot></incMenuShot>
      <div class="clear mt-40 search">
        <div class="w-40per float-left">
          <ul>
            <li>
              <select name="" id="" v-model="input.selectedMonth" @change="getJournalList()">
                <option :value="item" v-for="(item, index) in months" :key="index">{{ item }}</option>
              </select>
            </li>
          </ul>
        </div>
        <div class="w-60per float-left pl-30">
          <ul>
            <li>
              <select name="" id="" class="w-100per" v-model="input.whetherWriteFlag" @change="getJournalList()">
                <option value="unwritten">미작성</option>
                <option value="write">작성</option>
                <option value="">전체</option>
              </select>
            </li>
          </ul>
        </div>
      </div>

      <div class="coaching-list">
        <div class="coaching">
          <ul>
            <!-- <li class="clear default" @click="journalWrite()">
                            <div class="w-40per float-left">
                                <span>전화</span>
                                <h1>김소연</h1>
                            </div>
                            <div class="w-60per float-left">
                                <p>2021.08.11 09:00~10:00&nbsp;&nbsp;|&nbsp;&nbsp;2/10</p>
                            </div>
                        </li> -->

            <li class="clear more" v-for="(item, index) in list" :key="index" @click="journalWrite(item.sessionIdx, item.coarchingnoteIdx, item.courseIdx)">
              <div class="w-80per float-left">
                <div>
                  <span>{{ item.sessionType }}</span>
                  <h1>{{ item.userName }}</h1>
                </div>
                <p class="date">
                  {{ item.startDate }} {{ item.startTime }} ~ {{ item.endTime }}<b class="bold ml-10">{{ item.sessionPer }}/{{ item.courseOneperson }}</b>
                </p>
              </div>
              <div class="w-20per float-left">
                <p class="state">{{ item.status }}</p>
              </div>
              <!-- <div class="w-80per float-left">
                                <div>
                                    <span v-if="item.courseType == '1'">전화</span>
                                    <span v-if="item.courseType == '2'">화상</span>
                                    <span v-if="item.courseType == '3'">대면</span>
                                    <span v-if="item.courseType != '1' && item.courseType != '2' && item.courseType != '3'">{{item.courseType}}</span>
                                    <h1>{{item.userName}}</h1>
                                </div>
                                <p class="date">{{item.courseDate}}  {{item.courseTime}}&nbsp;&nbsp;|&nbsp;&nbsp;<b class="bold">{{item.courseSession}}</b></p>
                            </div>
                            <div class="w-20per float-left">
                                <p class="state">{{item.courseStatus}}</p>
                            </div> -->
            </li>
          </ul>
        </div>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import incTab from "@/components/inc/inc_tab.vue";
import incMenuShot from "@/components/inc/inc_menu_shot.vue";
import { pad } from "@/utils/common.js";
import dayjs from "dayjs";
export default {
  name: "coaching_journal",
  data: () => ({
    list: [],
    months: [],
    input: {
      selectedMonth: "",
      whetherWriteFlag: "",
    },
  }),
  components: {
    incBack,
    incTab,
    incMenuShot,
  },
  mounted() {
    console.log(localStorage.getItem("idxTbCoarch"));
    let date = new Date();
    let year = date.getFullYear();
    this.input.selectedMonth = year + "-" + pad(date.getMonth() + 1);
    for (let i = 0; i < 12; i++) {
      let value = year + "-" + pad(i + 1);
      // console.log(value)
      this.months.push(value);
    }
    this.getJournalList();
    // setInterval(() => {
    //   this.getJournalList();
    // }, 2000);
    // console.log(year);
  },
  methods: {
    getJournalList() {
      let params = this.input;
      this.axios
        .get("/front/coarching/complete/note/list", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.list = res.data.data;
            for (let item of this.list) {
              item.startTime = dayjs(item.startDatetime).format("HH:mm");
              item.endTime = dayjs(item.endDatetime).format("HH:mm");
              item.startDate = dayjs(item.startDatetime).format("YYYY.MM.DD");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    journalWrite(sessionIdx, coarchingnoteIdx, courseIdx) {
      if (coarchingnoteIdx == null) {
        this.$router.push({ name: "coaching_journal_write", params: { sessionIdx: Number(sessionIdx), courseIdx: courseIdx } });
      } else {
        this.$router.push({ name: "coaching_journal_view", params: { sessionIdx: Number(sessionIdx) } });
      }
    },
  },
};
</script>
